import { WifiProtocolConfig } from '@iotize/tap/config/schema/v1';
import { WifiMode } from '@iotize/tap/service/impl/wifi';

import {
  ascii,
  enumIntToEnumStringConverter,
  ipv4String,
  wifiMode,
} from '../converters';
import { VirtualTap } from '../virtual-tap-server';

export class WifiService {
  get config() {
    return this.server.config;
  }

  get wifi(): WifiProtocolConfig {
    if (!this.config.wireless) {
      this.config.wireless = {};
    }
    if (!this.config.wireless.protocols) {
      this.config.wireless.protocols = {};
    }
    if (!this.config.wireless.protocols.wifi) {
      this.config.wireless.protocols.wifi = {
        mode: 'NETWORK',
        ssid: '',
        key: '',
      };
    }
    return this.config.wireless.protocols.wifi;
  }

  constructor(public server: VirtualTap) {
    this.server.bindConfigToRoute({
      path: '/1024//25',
      get: true,
      put: true,
      item: () => this.wifi,
      key: 'ssid',
      default: '',
      converter: ascii,
    });
    this.server.bindConfigToRoute({
      path: '/1024//16',
      get: true,
      put: true,
      item: () => this.wifi,
      key: 'key',
      default: '',
      converter: ascii,
    });
    this.server.bindConfigToRoute({
      path: '/1024//15',
      get: true,
      put: true,
      item: () => this.wifi,
      key: 'mode',
      default: 'NETWORK',
      converter: enumIntToEnumStringConverter(wifiMode, WifiMode),
    });

    this.server.bindConfigToRoute({
      path: '/1024//30',
      item: () => this.wifi,
      key: 'ip',
      default: '0.0.0.0',
      converter: ipv4String,
      get: true,
      put: true,
    });

    this.server.bindConfigToRoute({
      path: '/1024//31',
      item: () => this.wifi,
      key: 'gatewayIp',
      default: '0.0.0.0',
      converter: ipv4String,
      get: true,
      put: true,
    });

    this.server.bindConfigToRoute({
      path: '/1024//32',
      item: () => this.wifi,
      key: 'mask',
      default: '0.0.0.0',
      converter: ipv4String,
      get: true,
      put: true,
    });
  }
}
